export default "__VITE_ASSET__BOkGGvvh__"